"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _subComponents = require("./subComponents/");

var _styler = _interopRequireDefault(require("../Styler/styler"));

var _dropdownUtils = require("./dropdownUtils");

var _unique = _interopRequireDefault(require("../helpers/unique.id"));

var _getNativeProps = _interopRequireDefault(require("../helpers/get-native-props"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Dropdown = function Dropdown(_ref) {
  var id = _ref.id,
      children = _ref.children,
      borderless = _ref.borderless,
      alignRight = _ref.alignRight,
      disabled = _ref.disabled,
      fluid = _ref.fluid,
      loading = _ref.loading,
      checked = _ref.checked,
      small = _ref.small,
      large = _ref.large,
      warning = _ref.warning,
      error = _ref.error,
      _ref$tabIndex = _ref.tabIndex,
      tabIndex = _ref$tabIndex === void 0 ? '0' : _ref$tabIndex,
      onFocus = _ref.onFocus,
      open = _ref.open,
      upward = _ref.upward,
      props = _objectWithoutProperties(_ref, ["id", "children", "borderless", "alignRight", "disabled", "fluid", "loading", "checked", "small", "large", "warning", "error", "tabIndex", "onFocus", "open", "upward"]);

  var loadingState = (0, _dropdownUtils.getLoadingState)({
    checked: checked,
    error: error,
    loading: loading
  });
  var allowedModifiers = {
    active: open,
    borderless: borderless,
    loadingState: loadingState,
    disabled: disabled,
    small: small,
    large: large,
    warning: warning,
    alignRight: alignRight
  };
  var dropdownStyles = ['co-dropdown', {
    'co-dropdown--fluid': fluid,
    'co-dropdown--upward': upward
  }];
  var uid = id || (0, _unique.default)();
  return _react.default.createElement(_styler.default, {
    classNames: dropdownStyles,
    modifiers: allowedModifiers
  }, function (styles) {
    return _react.default.createElement("div", _extends({
      id: uid,
      className: styles,
      onFocus: onFocus,
      tabIndex: tabIndex
    }, (0, _getNativeProps.default)(props)), children);
  });
};

Dropdown.Selection = _subComponents.DropdownSelection;
Dropdown.Menu = _subComponents.DropdownMenu;
Dropdown.Action = _subComponents.DropdownAction;
Dropdown.Actions = _subComponents.DropdownActions;
Dropdown.Scrollable = _subComponents.DropdownScrollable;
Dropdown.Options = _subComponents.DropdownOptions;
Dropdown.LoadMore = _subComponents.DropdownLoadMore;
Dropdown.NoResultsMessage = _subComponents.DropdownNoResultsMessage;
Dropdown.Search = _subComponents.DropdownSearch;
Dropdown.Option = _subComponents.DropdownOption;
Dropdown.Option.Content = _subComponents.DropdownOptionContent;
Dropdown.Option.Description = _subComponents.DropdownOptionDescription;
Dropdown.OptionGroup = _subComponents.DropdownOptionGroup;
Dropdown.OptionGroup.Title = _subComponents.DropdownOptionGroupTitle;
Dropdown.propTypes = {
  id: _propTypes.string,
  children: _propTypes.any,
  borderless: _propTypes.bool,
  alignRight: _propTypes.bool,
  disabled: _propTypes.bool,
  fluid: _propTypes.bool,

  /** {bool} Mutually exclusive props: @@loading@@ @@checked@@ @@error@@ */
  loading: _dropdownUtils.statusProps,

  /** {bool} Mutually exclusive props: @@loading@@ @@checked@@ @@error@@ */
  checked: _dropdownUtils.statusProps,

  /** {bool} Mutually exclusive props: @@loading@@ @@checked@@ @@error@@ */
  error: _dropdownUtils.statusProps,

  /** {bool} Mutually exclusive props: @@small@@ @@large@@ */
  small: _dropdownUtils.sizeProps,

  /** {bool} Mutually exclusive props: @@small@@ @@large@@ */
  large: _dropdownUtils.sizeProps,
  open: _propTypes.bool,
  tabIndex: _propTypes.string,
  onFocus: _propTypes.func,
  upward: _propTypes.bool
};
var _default = Dropdown;
exports.default = _default;
Dropdown.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Dropdown",
  "props": {
    "tabIndex": {
      "defaultValue": {
        "value": "'0'",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "id": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "children": {
      "type": {
        "name": "any"
      },
      "required": false,
      "description": ""
    },
    "borderless": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "alignRight": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "disabled": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "fluid": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "loading": {
      "type": {
        "name": "custom",
        "raw": "statusProps"
      },
      "required": false,
      "description": "{bool} Mutually exclusive props: @@loading@@ @@checked@@ @@error@@"
    },
    "checked": {
      "type": {
        "name": "custom",
        "raw": "statusProps"
      },
      "required": false,
      "description": "{bool} Mutually exclusive props: @@loading@@ @@checked@@ @@error@@"
    },
    "error": {
      "type": {
        "name": "custom",
        "raw": "statusProps"
      },
      "required": false,
      "description": "{bool} Mutually exclusive props: @@loading@@ @@checked@@ @@error@@"
    },
    "small": {
      "type": {
        "name": "custom",
        "raw": "sizeProps"
      },
      "required": false,
      "description": "{bool} Mutually exclusive props: @@small@@ @@large@@"
    },
    "large": {
      "type": {
        "name": "custom",
        "raw": "sizeProps"
      },
      "required": false,
      "description": "{bool} Mutually exclusive props: @@small@@ @@large@@"
    },
    "open": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "onFocus": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "upward": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    }
  }
};